import React from 'react';
import FlowProvider from './FlowContext';
import FlowContainer from './FlowContainer';

const Flow = () => {
  return (
    <FlowProvider>
      <FlowContainer />
    </FlowProvider>
  );
};

export default Flow;
